import {
  EditableWireframes,
  Wireframes,
} from '@components/ArtBoard/Block/Wireframes'
import type { BlockWireframe, ID } from '@octopus-do/octopus-project-core'
import { thunkUpdateSingleBlockWireframes } from '@store/migrationActions/thunkActions/thunkBlocksActions'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type { AppState } from '@store/types'
import type React from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import type { Action } from 'redux'
import type { ThunkDispatch } from 'redux-thunk'

interface Props {
  blockId: ID
  completed: boolean
  imageClass: string
  // The wireframes can be reordered and removed: the block's wireframes
  // popover is open and the project is writable.
  editable: boolean
}

export const BlockVisual: React.FC<Props> = ({
  blockId,
  completed,
  editable,
  imageClass,
}) => {
  const dispatch = useDispatch<ThunkDispatch<AppState, unknown, Action>>()

  const { colorId, visual } = useSelector(
    migrationProjectSelector.getProjectBlockOrSymbolData(blockId),
    shallowEqual
  )

  const onWireframesChange = (wireframes: BlockWireframe[]) => {
    dispatch(thunkUpdateSingleBlockWireframes({ id: blockId, wireframes }))
  }

  if (visual.type === 'wireframes') {
    if (editable) {
      return (
        <EditableWireframes
          colorId={colorId}
          completed={completed}
          onChange={onWireframesChange}
          wireframes={visual.wireframes}
        />
      )
    }

    return (
      <Wireframes
        wireframes={visual.wireframes}
        colorId={colorId}
        completed={completed}
      />
    )
  }

  const {
    image: { thumbnailUrl, id },
  } = visual

  return (
    <div className={imageClass}>
      <img src={thumbnailUrl} alt={id} />
    </div>
  )
}
